import { Sidebar } from 'flowbite-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { ChartPieIcon, DocumentDuplicateIcon, ListBulletIcon, PencilSquareIcon } from '@heroicons/react/24/solid'

const SidebarComponents = () => {
    return (
        <>
            <div className="w-fit bg-gray-50 border-r border-b border-solid border-stone-200 sm:hidden md:hidden lg:block xl:block">
                <Sidebar aria-label="Default sidebar example">
                    <Sidebar.Items>
                        <Sidebar.ItemGroup>
                            <h1 className="ml-3 font-bold">Menu</h1>
                            <li>
                                <Link to="/dashboard" className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                                    <ChartPieIcon className="h-5 w-5" />
                                    <span className="ml-3">Dashboard</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/dashboard/list-job-vacancy" className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                                    <DocumentDuplicateIcon className="h-5 w-5" />
                                    <span className="ml-3">Manage Data</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/list-job" className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                                    <ListBulletIcon className="h-5 w-5" />
                                    <span className="ml-3">List Job Vacancy</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/dashboard/list-job-vacancy/form" className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                                    <PencilSquareIcon className="h-5 w-5" />
                                    <span className="ml-3">Form Job</span>
                                </Link>
                            </li>
                        </Sidebar.ItemGroup>
                    </Sidebar.Items>
                </Sidebar>
            </div>
        </>
    )
}

export default SidebarComponents
